import React from "react";
import Map from "./Map";
import { useJsApiLoader } from "@react-google-maps/api";
import Button from "react-bootstrap/Button";
import { useState } from "react";

function LMHomeBody() {
  const strGMK =
    window._env_?.REACT_APP_GOOGLE_MAPS_API_KEY ||
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const { isLoaded, loadError } = useJsApiLoader({
    id: strGMK || "fallback",
    googleMapsApiKey: strGMK || "",
  });

  if (!strGMK) {
    return (
      <div className="container-fluid body-font">
        <div className="alert alert-warning" role="alert">
          <strong>Mappa non disponibile</strong> - Configurazione mancante. Si
          prega di contattare il supporto.
        </div>
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="container-fluid body-font">
        <div className="alert alert-danger" role="alert">
          <strong>Mappa non disponibile</strong> - Impossibile caricare Google
          Maps. Riprova più tardi.
        </div>
      </div>
    );
  }

  const [downloading, setDownloading] = useState(false);
  const handleDownload = async () => {
    setDownloading(true);
    try {
      const response = await fetch(
        "https://resources.hertz247.ufofleet.com/publishing/howto/itguide.pdf",
      );

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "itguide.pdf";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Errore durante il download:", error);
      // Fallback: open in new tab if download fails
      window.open(
        "https://resources.hertz247.ufofleet.com/publishing/howto/itguide.pdf",
        "_blank",
      );
    } finally {
      setDownloading(false);
    }
  };

  return (
    <>
      <div style={{ width: "80%" }} className="container-fluid p-4 body-font">
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <img
              src="https://images.hertz.com/content/dam/hod/images/it-it/static/side_van_logo.png"
              className="img-fluid"
              alt="Hertz24x7"
            />
          </div>
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <h1 className="display-5">Serve un furgone?</h1>
            <p className="h5">Noleggialo da € 14.99 per ora. *</p>
            <br />
          </div>
          <div
            className="col-xs-12"
            style={{
              textAlign: "left",
              width: "80%",
              justifyContent: "center",
            }}
          >
            <p className="h5">
              <b>Registrati</b>
            </p>
            Scarica l'app Hertz 24/7 e iscriviti gratis.
            <br />
            <br />
            <br />
            <p className="h5">
              <b>Prenota</b>
            </p>
            Scegli il tuo furgone per il tempo che ti serve.
            <br />
            <br />
            <br />
            <p className="h5">
              <b>Parti</b>
            </p>
            Apri con la tua app e parti.
          </div>
        </div>

        <br />
        <br />
        <br />

        <div className="row">
          <div
            className="col-xs-12 col-md-3"
            style={{
              textAlign: "center",
              backgroundColor: "#FFD101",
              fontWeight: "bold",
            }}
          >
            <br />
            <p className="h4">10</p>
            <p>Città</p>
          </div>
          <div
            className="col-xs-12 col-md-3 "
            style={{
              textAlign: "center",
              backgroundColor: "#FFD101",
              fontWeight: "bold",
            }}
          >
            <br />
            <p className="h4">20</p>
            <p>Store</p>
          </div>
          <div
            className="col-xs-12 col-md-3"
            style={{
              textAlign: "center",
              backgroundColor: "#FFD101",
              fontWeight: "bold",
            }}
          >
            <br />
            <p className="h4">25</p>
            <p>Van</p>
          </div>
          <div
            className="col-xs-12 col-md-3"
            style={{
              textAlign: "center",
              backgroundColor: "#FFD101",
              fontWeight: "bold",
            }}
          >
            <br />
            <p className="h4">2</p>
            <p>Taglie</p>
          </div>
        </div>

        <br />
        <br />
        <br />
        <div
          className="row"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Map isLoaded={isLoaded} />
        </div>

        <br />
        <br />
        <br />

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <div className="row">
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  style={{ width: "480px", borderRadius: "15px" }}
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/it-it/static/citroen.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-8"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h3">
                        <b>CITROEN</b>
                      </p>
                      <p className="h4">
                        <b>JUMPY</b>
                      </p>
                      <p className="h5">(o similare)</p>
                      <br />
                      <p className="h6">
                        <b>Categoria : B4</b>
                      </p>
                      <p className="h6">
                        <b>Alimentazione : Diesel</b>
                      </p>
                      <p className="h6">
                        <b>Potenza : 120 CV</b>
                      </p>
                      <p className="h6">
                        <b>Portata : c.a. 1200 kg</b>
                      </p>
                      <p className="h6">
                        <b>Autonomia : 700 km</b>
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
              <div
                className="col-xs-12 col-md-6"
                style={{ textAlign: "center" }}
              >
                <img
                  style={{ width: "480px", borderRadius: "15px" }}
                  className="img-fluid"
                  src="https://images.hertz.com/content/dam/hod/images/it-it/static/iveco.png"
                  alt=""
                />
                <br /> <br />
                <div className="row">
                  <div
                    className="col-xs-12 col-md-3"
                    style={{ textAlign: "center" }}
                  ></div>
                  <div
                    className="col-xs-12 col-md-8"
                    style={{ textAlign: "center" }}
                  >
                    <div style={{ textAlign: "left" }}>
                      <p className="h2">
                        <b>IVECO</b>
                      </p>
                      <p className="h4">
                        <b>DAILY</b>
                      </p>
                      <p className="h5">(o similare)</p>
                      <br />
                      <p className="h6">
                        <b>Categoria : C4</b>
                      </p>
                      <p className="h6">
                        <b>Alimentazione : Diesel</b>
                      </p>
                      <p className="h6">
                        <b>Potenza : 152 CV</b>
                      </p>
                      <p className="h6">
                        <b>Portata : c.a. 1270 kg</b>
                      </p>
                      <p className="h6">
                        <b>Autonomia : 600 km</b>
                      </p>
                    </div>
                  </div>
                  <div
                    className="col-xs-12 col-md-1"
                    style={{ textAlign: "center" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <span>
              <h6>
                <i>
                  Tutti i nostri van sono dotati di una tessera carburante con
                  cui è possibile rifornire il van fino a €50 al giorno
                </i>
              </h6>
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12" style={{ textAlign: "center" }}>
            <br />
            <span>
              <Button
                onClick={handleDownload}
                disabled={downloading}
                variant="warning"
                style={{
                  color: "white",
                  fontWeight: "bold",
                  backgroundColor: "#FFD101",
                  borderColor: "#FFD101",
                }}
              >
                {downloading
                  ? "Scarica in corso..."
                  : "Scarica la guida al noleggio"}
              </Button>
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
export default LMHomeBody;
